import { ISharedDiagnostic } from './diagnostics'
import { AnalysisTypeEnum, IAnalysis } from './ia-analysis'
import { IImageZoneReport } from './image-zone'

export interface IDiagnosticImage<T extends IAnalysis = IAnalysis> {
  id: string
  diagnosticId: string
  coordinates: {
    height: number
    width: number
    positive: Array<any>
    negative: Array<any>
    customPositive: Array<any>
  }
  imageFilePath: string
  errorMessage?: string | null
  mediaUrl: string
  process: DiagnosticImageProcessEnum
  createdAt: string
  updatedAt: string
  diagnostic?: ISharedDiagnostic
  analysisId?: string
  analysisType?: AnalysisTypeEnum
  analysis?: T
}

export enum DiagnosticImageProcessEnum {
  NotStarted = 'notStarted',
  Failed = 'failed',
  Success = 'success',
  InProgress = 'inProgress',
}

export type IDiagnosticImageWithAnalysis<T extends IAnalysis = IAnalysis> =
  IDiagnosticImage<T> & {
    analysis: T
  }

export interface IDiagnosticImageReport extends IDiagnosticImageWithAnalysis {
  imageZones: IImageZoneReport[]
}
